document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".sfb-frontend-form").forEach(form => {
    const endpoint = form.dataset.endpoint;
    const nonce = form.dataset.nonce;
    const statusEl = form.querySelector(".sfb-form-status");

    form.addEventListener("submit", async e => {
      e.preventDefault();
      statusEl.textContent = "Submitting...";

      const payload = {
        email: form.querySelector('input[name="email"]').value,
        option: form.querySelector('select[name="option"]').value,
        message: form.querySelector('textarea[name="message"]').value,
        "g-recaptcha-response": form.querySelector('#g-recaptcha-response').value,
      };

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": nonce,
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (data.status === "success") {
          statusEl.textContent = "✅ " + data.message;
          form.reset();
        } else {
          statusEl.textContent = "❌ " + (data.message || "Error");
        }
      } catch (err) {
        console.error(err);
        statusEl.textContent = "❌ Network error.";
      }
    });
  });
});
